export const vehicleAmortizationType = [
{
  value: '2',
  label: 'Escolher melhor taxa',
}
];
